import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NumberExtra } from '../../filter-drawer.types';
import { BaseSlotComponent } from '../base-slot.component';
import { AppTableFilterOperator } from 'app/shared/components/table/app-table.types';
import { TranslocoService, TranslocoPipe } from '@ngneat/transloco';
import { ZardInputDirective } from '../../../ui/input/input.directive';
import { ZardSelectComponent } from '../../../ui/select/select.component';
import { ZardSelectItemComponent } from '../../../ui/select/select-item.component';

@Component({
    selector: 'number-slot',
    templateUrl: './number-slot.component.html',
    styleUrl: './number-slot.component.css',
    standalone: true,
    imports: [
        ZardInputDirective,
        ZardSelectComponent,
        ZardSelectItemComponent,
        ReactiveFormsModule,
        TranslocoPipe
    ],
})
export class NumberSlotComponent extends BaseSlotComponent implements OnInit {
    maxLength?: number;
    pattern?: string;
    min?: number;
    max?: number;
    step?: number;

    showOperatorSelection = false;

    constructor(
        private elRef: ElementRef,
        private _translocoService: TranslocoService,
    ) {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
        const extra = this.slot.extra || {};
        const { min, max, step } = extra as NumberExtra;
        this.min = min;
        this.max = max;
        this.step = step;
    }

    toggleOperatorSelection(event?: Event): void {
        if (event) {
            event.stopPropagation();
        }
        this.showOperatorSelection = !this.showOperatorSelection;
    }

    get hasOperatorOptions(): boolean {
        return this.slot.operatorOptions && this.slot.operatorOptions.length > 0;
    }

    getOperatorLabel(operator: AppTableFilterOperator): string {
        switch (operator) {
            case AppTableFilterOperator.EQUALS:
                return this._translocoService.translate('filters.operators.equals');
            case AppTableFilterOperator.CONTAINS:
                return this._translocoService.translate('filters.operators.contains');
            case AppTableFilterOperator.LESS_THAN:
                return this._translocoService.translate('filters.operators.lessThan');
            case AppTableFilterOperator.LESS_THAN_OR_EQUALS:
                return this._translocoService.translate('filters.operators.lessThanOrEquals');
            case AppTableFilterOperator.GREATER_THAN:
                return this._translocoService.translate('filters.operators.greaterThan');
            case AppTableFilterOperator.GREATER_THAN_OR_EQUALS:
                return this._translocoService.translate('filters.operators.greaterThanOrEquals');
            default:
                return '';
        }
    }

    @HostListener('document:click', ['$event'])
    onOutsideClick(event: Event): void {
        if (this.showOperatorSelection && !this.elRef.nativeElement.contains(event.target)) {
            this.showOperatorSelection = false;
        }
    }
}
